export const phoneMask = (value) => {
  const digits = String(value ?? '').replace(/\D/g, '');
  if (digits.length > 10) {
    return digits.replace(/^(\d\d)(\d{5})(\d{4}).*/, '($1) $2-$3');
  }
  return digits.replace(/^(\d\d)(\d{4})(\d{4}).*/, '($1) $2-$3');
};
